export const calculateShopifyApiVersion = () => {
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1

    let quarter: string
    if (month <= 3) {
        quarter = '01'
    } else if (month <= 6) {
        quarter = '04'
    } else if (month <= 9) {
        quarter = '07'
    } else {
        quarter = '10'
    }

    return `${year}-${quarter}`
}

export const getShipifyProductLink = (slug: string) => `https://tdxcr.com/products/${slug}`

// ///////////
export type Product = {
    id: number
    title: string // название продукта
    body_html: string // описание продукта, нужно парсить
    vendor: string
    product_type: string
    created_at: string
    handle: string // аналог нашего slug для игрушки, используется в урлах
    updated_at: string
    published_at: string | null
    template_suffix: string
    published_scope: string
    tags: string
    status: 'active' | 'archived' | 'draft' // не отобржаются в shopify, если нужно, можно по ним фильтр сделать
    admin_graphql_api_id: string
    variants: Variant[]
    options: Option[]
    images: Image[] // дополнительные фотки для карусели
    image: Image // основная фотка
}

type Variant = {
    id: number
    product_id: number
    title: string
    price: string
    position: number
    inventory_policy: string
    compare_at_price: string | null
    option1: string
    option2: string | null
    option3: string | null
    created_at: string
    updated_at: string
    taxable: boolean
    barcode: string
    fulfillment_service: string
    grams: number
    inventory_management: string | null
    requires_shipping: boolean
    sku: string
    weight: number
    weight_unit: string
    inventory_item_id: number
    inventory_quantity: number
    old_inventory_quantity: number
    admin_graphql_api_id: string
    image_id: number | null
}

type Option = {
    id: number
    product_id: number
    name: string
    position: number
    values: string[]
}

type Image = {
    id: number
    alt: string | null
    position: number
    product_id: number
    created_at: string
    updated_at: string
    admin_graphql_api_id: string
    width: number
    height: number
    src: string
    variant_ids: number[]
}

export type ProductsResponse = {
    products: Product[]
}

export const ACCESS_TOKEN = process.env.SHOPIFY_ADMIN_API_ACCESS_TOKEN
export const store_name = 'iuesax-i4'
export const BASE_URL = `https://${store_name}.myshopify.com`
